import React from 'react'
import style from "./Property.module.css";

const Bond = ({index, key_name, handleInput, data}) => {

  return (
    <div className={style.add_txt}>
      <div className={style.item_input_text}>
        <p className={style.tit}>항목</p>
        <input type="text" name={`${key_name}_kind`} data-index={index} placeholder='임차보증금' value={data?.kind} onChange={handleInput}/>
      </div>

      <div className={style.item_input_text}>
        <p className={style.tit}>상세 내용</p>
        <div className={style.item_input_textarea}>
          <textarea name={`${key_name}_detail`} data-index={index} placeholder='현재 거주지(서울 강남구 00로 00길 00아파트 101동 1111호) 보증금 4억원 내고 살고 있음.' value={data?.detail} onChange={handleInput}/>
        </div>
      </div>

      <div className={style.item_input_text}>
        <p className={style.tit}>증거자료 유무</p>
        <input type="text" name={`${key_name}_evidence`} data-index={index} placeholder='임대차계약서' value={data?.evidence} onChange={handleInput}/>
      </div>
    </div>
  )
}

export default Bond